import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/WebReputation/ActionNotification';
import ApproveBlockList from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/WebReputation/ApproveBlockList';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/WebReputation/Rules';

const WebReputation = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.approvedAndBlockedList')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules
              applyBoundShow={true}
              retroScanShow={true}
              timeOfClickShow={true}
              detectionTequeniquesShow={true}
            />
          </TabPanel>
          <TabPanel>
            <ApproveBlockList tocProtectionShow={true} />
          </TabPanel>
          <TabPanel>
            <ActionNotification />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(WebReputation);
